import { CreateWeddingState } from '..';
import { PaletteHydrationState } from '../../CreateWeddingHydration';
import { CreateEventJson, CalendarDateType } from '../types';

export const addMonths = (date: Date, months: number) => new Date(date.setMonth(date.getMonth() + months));

export const removeTrailingWhiteSpace = (value: string) => value.trim();

export const getCreateEventData = (
  state: CreateWeddingState,
  data: PaletteHydrationState | undefined
): CreateEventJson => {
  const { ownerFirstName, ownerLastName, partnerFirstName, partnerLastName, location, eventDate } = state;
  let dateTime = addMonths(new Date(), 9).getTime();
  let calendarDate: CalendarDateType = {
    year: undefined,
    month: undefined,
    dayOfMonth: undefined
  };

  if (eventDate.value instanceof Date) {
    dateTime = eventDate.value.getTime();
    calendarDate.year = eventDate.value.getFullYear();
    calendarDate.month = eventDate.value.getMonth() + 1;
    calendarDate.dayOfMonth = eventDate.value.getDate();
  }

  let createEventData: CreateEventJson = {
    ownerFirstName: removeTrailingWhiteSpace(ownerFirstName.value),
    ownerLastName: removeTrailingWhiteSpace(ownerLastName.value),
    fianceeFirstName: removeTrailingWhiteSpace(partnerFirstName.value),
    fianceeLastName: removeTrailingWhiteSpace(partnerLastName.value),
    date: dateTime,
    place: location.value,
    placeId: location.placeId,
    lat: location.lat,
    lng: location.lng,
    template: 'aloha',
    theme: 'golden_haze',
    calendarDate,
    font: 'Roboto',
    tzid: location.tzid,
    tzMethod: location.tzMethod,
    backgroundType: null,
    enableTranslucentEffect: false,
    graphicAccent: null,
    useSuggestedBackgroundColor: true,
    useWeddingColor: false,
    palette: null,
    createdOnWeb: true
  };
  if (data) {
    createEventData = {
      ...createEventData,
      font: data.sections.fonts.font,
      backgroundType: null,
      enableTranslucentEffect: false,
      graphicAccent: null,
      useSuggestedBackgroundColor: data.sections.themes.useSuggestedBackgroundColor,
      useWeddingColor: !data.sections.themes.useSuggestedBackgroundColor,
      palette: data.palette,
      template: data.sections.layout.layout,
      theme: data.sections.themes.themeKey
    };
  }
  return createEventData;
};

export const createEventFromLocalStorage = () => {
  alert('Create Event');
};

export const getDefaultTimezone = () => {
  const currentLocation = Intl.DateTimeFormat().resolvedOptions();
  const browserTimeZone = currentLocation.timeZone;
  return {
    tzid: browserTimeZone ? browserTimeZone : 'America/Los_Angeles',
    tzMethod: browserTimeZone ? 'browser' : 'default'
  };
};
